import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import _ from "lodash";
import {
	actionDeleteFixedContribution,
	actionChangeFixedContributionProps,
	actionGetFixedContributionsList
} from "../../actions/FixedContributionActions";
import {
	Table,
	TableBody,
	TableHeader,
	TableHeaderColumn,
	TableRow,
	TableRowColumn
} from "material-ui/Table";
import {
	FIXED_CONTRIBUTIONS_NEW,
	FIXED_CONTRIBUTIONS_EDIT,
	INDEX
} from "../../config/RoutesConstants";
import {
	MODE_CRU_CREATE,
	MODE_CRU_UPDATE,
	MODE_CRU_SHOW
} from "../../actions/ActionConstants";
import { Card, CardTitle, CardText } from "material-ui/Card";
import Util, { SUCCESS, ERROR } from "../../common/Util";
import AppMem from "../../common/AppMem";
import OptionsTableRowColumn from "../../components/OptionsTableRowColumn/OptionsTableRowColumn";
import FilterCard from "../../components/FilterCard/FilterCard";
import Paginator from "../../components/Paginator/Paginator";
import { ROL_ADMIN, ROL_SUB_ADMIN } from "../../common/Constants";

let limitePagina = 10;

class FixedContributionsIndex extends Component {
	constructor(props) {
		super(props);
		this.handleDelete = this.handleDelete.bind(this);
		this.handleShow = this.handleShow.bind(this);
		this.onCreateOrUpdate = this.onCreateOrUpdate.bind(this);
		this.onTapConfirmDelete = this.onTapConfirmDelete.bind(this);
		this.getFixedContributions = this.getFixedContributions.bind(this);
		this.onChangePage = this.onChangePage.bind(this);
		this.renderBodyRows = this.renderBodyRows.bind(this);
		this.renderPaginator = this.renderPaginator.bind(this);
	}

	componentWillMount() {
		if (this.props.rol !== ROL_ADMIN && this.props.rol !== ROL_SUB_ADMIN) {
			this.props.history.push(INDEX);
		} else this.getFixedContributions(1, limitePagina);
	}

	getFixedContributions(page, limit) {
		let { searchtext } = this.props;
		this.props.actionGetFixedContributionsList(searchtext, page, limit);
	}

	renderPaginator() {
		return (
			<Paginator
				page={this.props.page}
				pageLimit={limitePagina}
				total={this.props.total}
				onChangePage={this.onChangePage}
			/>
		);
	}

	onCreateOrUpdate(fixedContribution) {
		if (fixedContribution) {
			this.props.actionChangeFixedContributionProps({
				fixedContribution: fixedContribution,
				modeCRU: MODE_CRU_UPDATE,
				searchtext: ""
			});
			this.props.history.push(FIXED_CONTRIBUTIONS_EDIT);
		} else {
			this.props.actionChangeFixedContributionProps({
				fixedContribution: null,
				modeCRU: MODE_CRU_CREATE,
				searchtext: ""
			});
			this.props.history.push(FIXED_CONTRIBUTIONS_NEW);
		}
	}

	handleDelete(fixedContribution) {
		AppMem.confirmDialog.open({
			title: "Eliminar contribución fija",
			messageConfirm: "¿Esta seguro que desea eliminar contribución fija?",
			onAccept: this.onTapConfirmDelete.bind(this, fixedContribution.id)
		});
	}

	handleShow(fixedContribution) {
		this.props.actionChangeFixedContributionProps({
			modeCRU: MODE_CRU_SHOW,
			fixedContribution: fixedContribution
		});
		this.props.history.push(FIXED_CONTRIBUTIONS_EDIT);
	}

	onTapConfirmDelete(fixedContributionId) {
		this.props.actionDeleteFixedContribution(
			fixedContributionId,
			this.returnConfirmDelete.bind(this)
		);
	}

	returnConfirmDelete(response) {
		if (response === SUCCESS) {
			this.getFixedContributions(this.props.page, limitePagina);
			Util.showNoty(response, "Contribución fija Eliminada");
		} else if (response === ERROR) {
			Util.showNoty(response, "Error al eliminar contribución fija");
		} else {
			Util.showNoty(
				response,
				"No se puede eliminar contribución fija, tiene elementos asociados"
			);
		}
	}

	renderBlank() {
		return (
			<TableRow key={1}>
				<TableRowColumn>
					<p>No se encontraron resultados</p>
				</TableRowColumn>
			</TableRow>
		);
	}

	onChangePage(page) {
		this.props.actionChangeFixedContributionProps({
			page: page
		});
		this.getFixedContributions(page, limitePagina);
	}

	renderBodyRows(fixedContributionsList) {
		let Edit = this.onCreateOrUpdate;
		let Delete = this.handleDelete;
		const Show = this.handleShow;
		return _.map(fixedContributionsList, (item, i) => {
			let fixedContribution = item;
			return (
				<TableRow key={i} style={{ height: "16px", fontSize: "12px" }}>
					<TableRowColumn style={{ marginLeft: 20 }}>
						{Util.formatDateToShowNotHour(fixedContribution.dateFrom)}
					</TableRowColumn>
					<TableRowColumn style={{ marginLeft: 20 }}>
						{Util.formatDateToShowNotHour(fixedContribution.dateTo)}
					</TableRowColumn>
					<TableRowColumn style={{ marginLeft: 20 }}>
						{Util.formatDouble(fixedContribution.baseSalary)}
					</TableRowColumn>
					<TableRowColumn style={{ marginLeft: 20 }}>
						{Util.formatDouble(fixedContribution.specialContribution)}
					</TableRowColumn>
					<TableRowColumn style={{ width: "20%" }}>
						<OptionsTableRowColumn
							handleEdit={() => Edit(item)}
							handleDelete={() => Delete(item)}
							handleShow={() => Show(item)}
							showTooltip="Ver"
						/>
					</TableRowColumn>
				</TableRow>
			);
		});
	}

	render() {
		return (
			<div className="center">
				<Card className="card">
					<CardTitle
						title="Contribución Fija"
						subtitle="Agregue o Modifique Contribuciones Fijas"
					/>
					<CardText>
						<FilterCard onTouchTapNew={() => this.onCreateOrUpdate()} />
						<Table selectable={false}>
							<TableHeader displaySelectAll={false} adjustForCheckbox={false}>
								<TableRow>
									<TableHeaderColumn>Fecha Desde</TableHeaderColumn>
									<TableHeaderColumn>Fecha Hasta</TableHeaderColumn>
									<TableHeaderColumn>Salario Base</TableHeaderColumn>
									<TableHeaderColumn>Contribución especial</TableHeaderColumn>
									<TableHeaderColumn style={{ width: "20%" }}>
										Acciones
									</TableHeaderColumn>
								</TableRow>
							</TableHeader>
							<TableBody stripedRows displayRowCheckbox={false}>
								{!_.isEmpty(this.props.fixedContributionsList)
									? this.renderBodyRows(this.props.fixedContributionsList)
									: this.renderBlank()}
							</TableBody>
						</Table>
					</CardText>
					{!_.isEmpty(this.props.fixedContributionsList)
						? this.renderPaginator()
						: ""}
				</Card>
			</div>
		);
	}
}

function mapStateToProps(store) {
	return {
		fixedContributionsList: store.fixedContribution.fixedContributionsList,
		loadingText: store.fixedContribution.loadingText,
		modeCRU: store.fixedContribution.modeCRU,
		page: store.fixedContribution.page,
		total: store.fixedContribution.total,
		rol: store.app.rol
	};
}
function mapDispatchToProps(dispatch) {
	return bindActionCreators(
		{
			actionDeleteFixedContribution,
			actionChangeFixedContributionProps,
			actionGetFixedContributionsList
		},
		dispatch
	);
}
export default connect(mapStateToProps, mapDispatchToProps)(
	FixedContributionsIndex
);



// WEBPACK FOOTER //
// ./src/screens/FixedContribution/FixedContributionIndex.js